// Profile.js
import React from 'react';
import { Box, Grid, Typography, List, ListItem } from '@mui/material';
import '../Docs.css';          // uses .steps-list and .thumb rules

export default function Profile() {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h2" gutterBottom>
        Profile &amp; Account
      </Typography>


        {/* —— Left column : features —— */}
          <List className="steps-list" sx={{ pl: 3, listStyleType: 'disc' }}>
            <ListItem>
              <strong>Account</strong> — shows the Google / email identity
              currently linked to PostSheet.
            </ListItem>
            <ListItem>
              <strong>Email usage</strong> — progress bar tracks how many mails
              you’ve sent versus the plan limit.
            </ListItem>
            <ListItem>
              <strong>Billing</strong> — opens the Stripe portal to update card
              details, invoices or subscription.
             
            </ListItem>
<ListItem>
  <Typography component="span">
    <strong>Delete account</strong> — If you want to unsubscribe, just click on the option at the bottom of the subscription card. Email&nbsp;
    <a
      href="mailto:support@postsheet.com"
      rel="noopener noreferrer"
    >
      support@postsheet.com
    </a>
    &nbsp;if you have any issues, and we’ll help you.
  </Typography>
</ListItem>
          </List>
     <img
            src="../../static/docs/Profile.jpg"
            alt="Profile page"
            className="step-img"
          />
    </Box>
  );
}
